import { FC } from "react";
import ImageCustom from "../../../components/custom/image-custom";
import { NotificationResponse } from "../../../models/response/notification/notification";
import { NOTIFICATION_OBJECT_TYPE } from "../../../constants/status";

interface ItemNotificationProps {
  notification: NotificationResponse;
  handleClick: () => void;
}

const ItemNotification: FC<ItemNotificationProps> = ({ notification, handleClick }: ItemNotificationProps) => {
  return (
    <li
      className={`cursor-pointer hover:bg-[#f1f3f5] transition-colors duration-200  `}
      onClick={() => {
        handleClick();
      }}
    >
      <div className="flex items-center px-4 py-2">
        <div className="flex-shrink-0">
          <ImageCustom
            className="object-cover w-10 h-10 rounded-full border border-[#f2f2f2]"
            isLocal={false}
            isNotify={true}
            url={notification.object_type === NOTIFICATION_OBJECT_TYPE.USER ? notification.user_notification.avatar : notification.image_url}
            isUser={notification.object_type === NOTIFICATION_OBJECT_TYPE.USER}
          />
        </div>

        <div className="flex-1 min-w-0 ltr:pl-4 rtl:pr-4">
          <div className="flex items-center justify-between">
            <h4 className="text-base font-semibold text-gray-900 truncate line-clamp-2" style={{ whiteSpace: "break-spaces" }}>
              {notification.title}
            </h4>
          </div>

          <p className="text-[14px] text-gray-500 break-words line-clamp-2 mt-1">{notification.message}</p>
        </div>
        {notification.read_at === "" && <div className="w-2.5 h-2.5 bg-blue-500 rounded-full flex-shrink-0 ltr:ml-2 rtl:mr-2"></div>}
      </div>
    </li>
  );
};

export default ItemNotification;
